
define('txt!modules/module.hbs',[],function () { return '<div class="module-front">\n  <div class="module-image">\n    {{#each images}}\n      <div class="module-image-{{@key}}" style="background-image:url(\'{{this}}\');"></div>\n    {{/each}}\n  </div>\n  <div class="module-body">\n    <div class="module-content">\n      {{content}}\n    </div>\n  </div>\n</div>\n';});

